var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("GESTORÍA KNK")]),_c('h2',[_vm._v("Gestoría Administrativa Moreno Moraleda")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }